import state from './informacastoutboundemail.state'
import mutations from './informacastoutboundemail.mutations'
import actions from './informacastoutboundemail.actions'

export default {
  state,
  mutations,
  actions
}
